import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { getBriefingAnalyses } from "../../api/briefing";
import { dispatchTokenExpiredEvent } from "../../utils/authEvents";
import type { WorkspaceScope } from "../../features/toolExperience/types";
export function useRecentBriefs(
  scope: WorkspaceScope | null,
  { q, status }: { q: string; status: string },
) {
  const { user } = useAuth();
  return useQuery({
    queryKey: [
      "tool-experience",
      "recent-briefs",
      scope?.userId,
      scope?.organizationId,
      q,
      status,
    ],
    enabled: !!scope && !!user,
    queryFn: async () =>
      (
        await getBriefingAnalyses(
          undefined,
          status === "all" ? undefined : status,
          50,
          user,
          dispatchTokenExpiredEvent,
          q || undefined,
        )
      ).filter(
        (a) => a.analysis_type === "combined" || a.analysis_type === "brief_v2",
      ),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
